<template>
  <div class="stock-slips">
    <KTCodePreview v-bind:title="'Danh sách giá vốn đầu kỳ'">
      <template v-slot:toolbar>
        <div class="row">
          <div>
            <b-dropdown size="sm" id="obc-dropdown-actions" right>
              <template slot="button-content">
                <i class="fas fa-cog mr-1" style="font-size: 1rem"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item :to="{ path: '/opening-stock-receipt' }">
                <span><i style="font-size: 1rem" class="flaticon2-supermarket mr-2"></i>Mở nhập kho đầu kỳ</span>
              </b-dropdown-item>
              <b-dropdown-item :to="{ path: '/inventory-cost-recalculation' }">
                <span><i style="font-size: 1rem" class="fas fa-calculator mr-2"></i>Giá vốn theo kỳ</span>
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item v-if="canView" @click="fetchChanges">
                <span><i style="font-size: 1rem" class="fas fa-sync-alt mr-2"></i>Làm mới danh sách</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="canEdit" class="ml-3">
            <b-dropdown size="sm" right split variant="primary" @click="goCreateProduct">
              <template v-slot:button-content>
                <span class="font-weight-bolder">
                  <i style="font-size: 1rem" class="flaticon2-add-1 mr-1"></i>
                  Thêm mới
                </span>
              </template>
              <b-dropdown-item @click="goCreateImei">
                <span><i style="font-size: 1rem" class="far fa-file-excel mr-2"></i>Nhập IMEI</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>

      <template v-slot:preview>
        <b-alert v-if="!canViewOrEdit" show variant="warning" class="border-0 mb-4">
          Cần quyền <code>OPENING_BALANCE_COST_VIEW</code> hoặc <code>OPENING_BALANCE_COST_EDIT</code>.
        </b-alert>

        <template v-else>
          <b-row class="mb-5 obc-list-obc-filter-row">
            <b-col cols="12" md="6" lg="3" class="mb-2 mb-lg-0">
              <div class="d-flex flex-nowrap align-items-center w-100 obc-list-obc-dates">
                <date-picker
                  placeholder="Từ ngày"
                  class="form-control-sm obc-list-obc-dates__picker"
                  :config="dpConfigs.start"
                  v-model="dpForm.startDate"
                />
                <span class="obc-list-obc-dates__sep flex-shrink-0">–</span>
                <date-picker
                  placeholder="Đến ngày"
                  class="form-control-sm obc-list-obc-dates__picker"
                  :config="dpConfigs.end"
                  v-model="dpForm.endDate"
                />
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4" class="mb-2 mb-lg-0">
              <b-form-input
                v-model="filterSearchProduct"
                type="text"
                placeholder="Nhập mã, tên, mã vạch sản phẩm"
                size="sm"
                trim
                maxlength="200"
                class="obc-list-obc-filter-input"
                @keyup.enter="onFilter"
              />
            </b-col>
            <b-col cols="12" md="6" lg="2" class="mb-2 mb-lg-0">
              <b-form-input
                v-model="filterImeiNo"
                type="text"
                placeholder="Tìm theo IMEI (serial)"
                size="sm"
                trim
                maxlength="64"
                class="obc-list-obc-filter-input"
                @keyup.enter="onFilter"
              />
            </b-col>
            <b-col cols="12" md="6" lg="2" class="mb-2 mb-lg-0">
              <b-form-select
                class="select-style obc-list-obc-filter-input"
                size="sm"
                v-model="selectedCompany"
                :options="listCompany"
                value-field="id"
                text-field="name"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Doanh nghiệp --</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-5 obc-list-obc-filter-row">
            <b-col cols="12" md="6" lg="3">
              <b-form-select class="select-style obc-list-obc-filter-input" size="sm" v-model="changesStockKind">
                <b-form-select-option value="">Tất cả</b-form-select-option>
                <b-form-select-option value="product-stock">Chỉ ProductStock</b-form-select-option>
                <b-form-select-option value="imei-stock">Chỉ IMEI stock</b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="mb-5">
            <b-col md="1">
              <b-button
                style="font-weight: 600; width: 70px"
                variant="primary"
                size="sm"
                :disabled="!canView"
                @click="onFilter"
              >
                Lọc
              </b-button>
            </b-col>
            <b-col md="auto">
              <b-button variant="secondary" size="sm" @click="clearFilters">
                <i class="fas fa-times mr-1"></i>
                Xóa bộ lọc
              </b-button>
            </b-col>
          </b-row>

          <b-alert v-if="changesHint" show variant="secondary" class="small py-2 border mb-3">
            {{ changesHint }}
          </b-alert>

          <b-table
            :items="changeRows"
            :fields="changeFields"
            class="table-bordered table-hover col-md-12 mb-0 inventory-receipt-table"
            responsive
            :busy="onLoading"
            show-empty
            empty-text="Không có bản ghi — chỉnh bộ lọc và bấm Lọc, hoặc dùng Thêm mới."
          >
            <template v-slot:table-busy>
              <vcl-table :speed="5" :animate="true" :columns="8"></vcl-table>
            </template>
            <template v-slot:cell(imeiId)="row">
              <span class="d-block text-break small">{{ formatImeiCell(row.item) }}</span>
            </template>
            <template v-slot:cell(productInfo)="row">
              <ProductCommonInfo :product="changeRowProductForInfo(row.item)" />
            </template>
            <template v-slot:cell(oldPrice)="row">
              {{ formatMoney(row.item.oldOriginalPrice ?? row.item.oldPrice) }}
            </template>
            <template v-slot:cell(newPrice)="row">
              {{ formatMoney(row.item.newOriginalPrice ?? row.item.newPrice) }}
            </template>
          </b-table>

          <div v-if="canView" class="d-flex flex-wrap justify-content-between align-items-center mt-3 pt-2 border-top">
            <span class="text-muted small mb-0">Tổng <strong>{{ totalItems }}</strong> dòng</span>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="currentPage"
              :total-page="totalPages"
              @page-change="onPageChange"
            />
          </div>
        </template>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import moment from 'moment';
import { VclTable } from 'vue-content-loading';
import KTCodePreview from '@/view/content/CodePreview.vue';
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import permissionMixin from '@/view/mixins/permission.mixin';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import { makeToastFaile } from '@/utils/common';
import { getOpeningBalanceCostChanges } from '@/services/openingBalanceCost.service';
import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  name: 'ListOpeningBalanceCost',
  mixins: [apiCommonMixin, permissionMixin],
  components: {
    KTCodePreview,
    VclTable,
    ProductCommonInfo,
    BPaginationNavCustom,
  },
  data() {
    return {
      dpForm: {
        startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
        endDate: '',
      },
      dpConfigs: {
        start: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
        end: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      onLoading: false,
      changesHint: '',
      changeRows: [],
      currentPage: 1,
      pageSize: 50,
      totalPages: 1,
      totalItems: 0,
      filterSearchProduct: '',
      filterImeiNo: '',
      selectedCompany: null,
      listCompany: [],
      changesStockKind: '',
      changeFields: [
        { key: 'idx', label: 'STT', tdClass: 'text-center align-middle text-muted', thStyle: { width: '42px', fontWeight: 600 } },
        { key: 'createdAt', label: 'Thời gian', thStyle: { fontWeight: 600, minWidth: '120px' } },
        {
          key: 'productInfo',
          label: 'Sản phẩm',
          thStyle: { fontWeight: 600, minWidth: '16rem', width: '28%' },
        },
        { key: 'imeiId', label: 'IMEI', thStyle: { fontWeight: 600, minWidth: '140px' } },
        { key: 'oldPrice', label: 'Giá vốn cũ', tdClass: 'text-right', thStyle: { fontWeight: 600 } },
        { key: 'newPrice', label: 'Giá vốn mới', tdClass: 'text-right font-weight-bold', thStyle: { fontWeight: 600 } },
        { key: 'userDisplay', label: 'Người thực hiện', thStyle: { fontWeight: 600 } },
        { key: 'memo', label: 'Ghi chú', thStyle: { fontWeight: 600 } },
      ],
    };
  },
  computed: {
    canView() {
      return this.checkPermission('OPENING_BALANCE_COST_VIEW');
    },
    canEdit() {
      return this.checkPermission('OPENING_BALANCE_COST_EDIT');
    },
    canViewOrEdit() {
      return this.checkPermission(['OPENING_BALANCE_COST_VIEW', 'OPENING_BALANCE_COST_EDIT']);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kho hàng', route: '/inventory-receipt' },
      { title: 'Giá vốn theo kỳ', route: '/inventory-cost-recalculation' },
      { title: 'Giá vốn đầu kỳ', route: '/opening-balance-cost' },
      { title: 'Danh sách — lịch sử chỉnh giá' },
    ]);
  },
  async created() {
    await this.fetchCompany();
    await this.fetchChanges();
  },
  methods: {
    formatMoney(v) {
      if (v == null || v === '') return '—';
      return new Intl.NumberFormat('vn-VN').format(Number(v));
    },
    changeRowProductForInfo(row) {
      if (!row || typeof row !== 'object') {
        return {
          productId: '',
          productName: '',
          productCode: '',
          barCode: '',
          productImageUrl: '',
        };
      }
      return {
        productId: row.productId || row.productUUID || row.productUuid || '',
        productName: row.productName || '',
        productCode: row.productCode || '',
        barCode: row.barCode != null ? String(row.barCode) : row.barcode != null ? String(row.barcode) : '',
        productImageUrl: row.productImageUrl || row.imageUrl || '',
      };
    },
    formatImeiCell(row) {
      if (!row || typeof row !== 'object') return '—';
      const serial =
        `${row.imeiCode || row.imeiiCode || row.imeiNo || row.serial || ''}`.trim();
      return serial || '—';
    },
    goCreateProduct() {
      this.$router.push({ name: 'add-opening-balance-cost' });
    },
    goCreateImei() {
      this.$router.push({ name: 'add-opening-imei-balance-cost' });
    },
    extractEnvelopeMessage(envelope, fallback = '') {
      return (envelope && (envelope.message || envelope.Message)) || fallback;
    },
    isHttpEnvelopeOk(envelope, allow = [200]) {
      return allow.includes(Number(envelope && envelope.status));
    },
    fetchCompany() {
      return ApiService.get('/v1/companies/all')
        .then((response) => {
          this.listCompany = response.data.data || [];
        })
        .catch(() => makeToastFaile('Không tải được danh sách doanh nghiệp.'));
    },
    onFilter() {
      this.currentPage = 1;
      this.fetchChanges();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchChanges();
    },
    clearFilters() {
      this.dpForm.startDate = moment().subtract(15, 'days').format('DD/MM/YYYY');
      this.dpForm.endDate = '';
      this.filterSearchProduct = '';
      this.filterImeiNo = '';
      this.changesStockKind = '';
      this.selectedCompany = null;
      this.currentPage = 1;
      this.fetchChanges();
    },
    extractPaginationMeta(payload, rowCount) {
      const d = payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
      const totalRow = Number(
        d.totalRow ?? d.totalRows ?? d.total ?? d.totalCount ?? d.totalItems ?? rowCount,
      );
      const totalPage = Number(
        d.totalPage ?? d.totalPages ?? d.total_page ?? (totalRow > 0 ? Math.ceil(totalRow / this.pageSize) : 1),
      );
      const currentPage = Number(d.currentPage ?? d.page ?? this.currentPage);
      return {
        totalItems: Number.isFinite(totalRow) && totalRow >= 0 ? totalRow : rowCount,
        totalPages: Number.isFinite(totalPage) && totalPage > 0 ? totalPage : 1,
        currentPage: Number.isFinite(currentPage) && currentPage > 0 ? currentPage : this.currentPage,
      };
    },
    async fetchChanges() {
      if (!this.canView) {
        this.changeRows = [];
        this.totalItems = 0;
        this.totalPages = 1;
        return;
      }
      this.onLoading = true;
      this.changesHint = '';
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
        };
        if (this.selectedCompany != null && this.selectedCompany !== '') {
          params.companyId = Number(this.selectedCompany);
        }
        if (this.dpForm.startDate) {
          params.from = moment(this.dpForm.startDate, 'DD/MM/YYYY').format('YYYY-MM-DDT00:00:00');
        }
        if (this.dpForm.endDate) {
          params.to = moment(this.dpForm.endDate, 'DD/MM/YYYY').format('YYYY-MM-DDT23:59:59');
        }
        const searchProduct = String(this.filterSearchProduct || '').trim().slice(0, 200);
        if (searchProduct) params.searchProduct = searchProduct;
        const imeiQ = String(this.filterImeiNo || '').trim().slice(0, 64);
        if (imeiQ) {
          params.imeiNo = imeiQ;
        }
        if (String(this.changesStockKind || '').trim()) {
          params.stockKind = String(this.changesStockKind).trim();
        }

        const axiosRes = await getOpeningBalanceCostChanges(params);
        const envelope = axiosRes.data;
        if (!this.isHttpEnvelopeOk(envelope, [200])) {
          throw new Error(this.extractEnvelopeMessage(envelope, 'Không đọc lịch sử'));
        }
        const d = envelope.data;
        let rows = [];
        let paginationSource = d;
        if (Array.isArray(d)) {
          rows = d;
          paginationSource = null;
        } else if (d && typeof d === 'object') {
          rows = Array.isArray(d.rows)
            ? d.rows
            : Array.isArray(d.items)
            ? d.items
            : Array.isArray(d.changes)
            ? d.changes
            : Array.isArray(d.data)
            ? d.data
            : [];
        }
        const pagination = this.extractPaginationMeta(paginationSource, (rows || []).length);
        this.totalItems = pagination.totalItems;
        this.totalPages = pagination.totalPages;
        this.currentPage = pagination.currentPage;
        const rowOffset = (this.currentPage - 1) * this.pageSize;
        this.changeRows = (rows || []).map((item, idx) => {
          const imeiCodeRaw = item.imeiCode != null ? String(item.imeiCode).trim() : '';
          const imeiiCodeRaw = item.imeiiCode != null ? String(item.imeiiCode).trim() : '';
          const imeiCodeNorm = imeiCodeRaw || imeiiCodeRaw || '';
          return Object.assign({}, item, {
            idx: rowOffset + idx + 1,
            userDisplay:
              item.employeeName ||
              item.userName ||
              item.createdBy ||
              (item.userId != null && item.userId !== '' ? `#${item.userId}` : '') ||
              '—',
            createdAt:
              item.createdAt || item.updatedAt
                ? moment(item.createdAt || item.updatedAt).format('DD/MM/YYYY HH:mm')
                : '—',
            memo: item.memo || item.note || item.description || '',
            productId: item.productId || item.productUUID || item.productUuid || '',
            productImageUrl: item.productImageUrl || item.imageUrl || '',
            imeiCode: imeiCodeNorm || item.imeiCode,
          });
        });
      } catch (e) {
        const st = e && e.response && e.response.status;
        if (st === 404) {
          this.changesHint =
            'API GET /opening-balance-cost/changes chưa sẵn sàng — dùng Thêm mới để gửi batch; khi backend bật, bảng sẽ có dữ liệu.';
        } else {
          makeToastFaile(this.extractEnvelopeMessage(e && e.response && e.response.data, e.message || 'Lỗi'));
        }
        this.changeRows = [];
        this.totalItems = 0;
        this.totalPages = 1;
      } finally {
        this.onLoading = false;
      }
    },
  },
};
</script>

<style lang="scss">
.stock-slips {
  /* Gutter nhỏ hơn mặc định để các ô có nhiều chỗ hiển thị chữ hơn */
  .obc-list-obc-filter-row {
    margin-left: -6px;
    margin-right: -6px;

    > div[class*='col'] {
      padding-left: 6px;
      padding-right: 6px;
    }
  }

  .obc-list-obc-filter-input.form-control {
    padding-left: 0.4rem;
    padding-right: 0.45rem;
  }

  select.obc-list-obc-filter-input.custom-select,
  select.obc-list-obc-filter-input.custom-select.custom-select-sm {
    padding-left: 0.4rem;
    padding-right: 1.65rem;
  }

  /* Hai date-picker cùng một hàng; không cho co nhỏ hơn nội dung ngày */
  .obc-list-obc-dates {
    min-width: 0;
  }

  .obc-list-obc-dates__sep {
    color: #b5b5c3;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    line-height: 1;
  }

  .obc-list-obc-dates__picker {
    flex: 1 1 0;
    min-width: 6.75rem;
  }

  .obc-list-obc-dates__picker::v-deep .form-control,
  .obc-list-obc-dates__picker::v-deep input {
    width: 100%;
    min-width: 6.75rem;
    padding-left: 0.4rem;
    padding-right: 0.35rem;
    overflow: visible;
  }

  .inventory-receipt-table {
    thead th {
      font-weight: 600;
      font-size: 0.8rem;
      padding: 0.5rem 0.4rem;
      background-color: #f8f9fa;
    }
    tbody td {
      font-size: 0.875rem;
      padding: 0.5rem 0.4rem;
    }
  }
}
</style>
